import { Canvg } from 'canvg'

export async function transformHTMLinCanvas(elementId: string): Promise<string>
export async function transformHTMLinCanvas(element: Element): Promise<string>
export async function transformHTMLinCanvas(elementId: string | Element): Promise<string> {
    let svg = null
    if (elementId instanceof Element) {
        svg = elementId.outerHTML
    } else {
        svg = document.getElementById(elementId).outerHTML
    }

    if (svg) svg = svg.replace(/\r?\n|\r/g, '').trim()

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    context.clearRect(0, 0, canvas.width, canvas.height)
    const data = await Canvg.from(context, svg)
    data.start()
    await new Promise<void>(resolve =>
        setTimeout(() => {
            data.stop()
            resolve()
        }, 1000)
    )
    const imgData = canvas.toDataURL('image/png')


    return imgData
}
